import {
	IconButton,
	InputAdornment,
	TextField as MuiTextField
} from '@mui/material'
import { merge } from 'lodash'

export default function TextField({ props, rest }: any) {
	const { icon } = rest

	const mergedProps = merge(
		{
			size: 'medium',
			sx: { lineHeight: '45px' },
			InputProps: {
				endAdornment: (
					<InputAdornment position='end'>
						<IconButton>{icon}</IconButton>
					</InputAdornment>
				)
			}
		},
		props
	)

	return <MuiTextField {...mergedProps} />
}
